import React, { useState, useCallback } from 'react';

import { cssMap } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { token } from '@atlaskit/tokens';

import type { ContributorData } from './hooks/useProcessedContributorsResult.ts';
import { ContributorItem } from './ContributorItem.tsx';
import { ShowMoreButton } from './ShowMoreButton.tsx';

const styles = cssMap({
	list: {
		paddingInlineStart: token('space.300'),
	},
});

export interface ListLayoutProps {
	visibleContributors: ContributorData[];
	hiddenContributors: ContributorData[];
	showCount: boolean;
	showTime: boolean;
}

export const ListLayout = ({
	visibleContributors,
	hiddenContributors,
	showCount,
	showTime,
}: ListLayoutProps): React.JSX.Element => {
	const [showHidden, setShowHidden] = useState(false);

	const handleShowMore = useCallback(
		(e: React.MouseEvent) => {
			e.preventDefault();
			setShowHidden(true);
		},
		[setShowHidden],
	);

	return (
		<Stack as="ul" xcss={styles.list} testId="contributors-list-layout">
			{visibleContributors.map((contributor) => (
				<li key={contributor.id}>
					<ContributorItem contributor={contributor} showCount={showCount} showTime={showTime} />
				</li>
			))}
			{hiddenContributors.length > 0 && !showHidden && (
				<li>
					<ShowMoreButton hiddenCount={hiddenContributors.length} onClick={handleShowMore} />
				</li>
			)}
			{showHidden &&
				hiddenContributors.map((contributor) => (
					<li key={contributor.id}>
						<ContributorItem contributor={contributor} showCount={showCount} showTime={showTime} />
					</li>
				))}
		</Stack>
	);
};
